// src/components/listing/ListingRowCard.js
// Carte compacte pour les rangées horizontales - compatible avec les données réelles - NE PAS MODIFIER

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../hooks/useTheme';
import { useLanguage } from '../../hooks/useLanguage';
import { useListings } from '../../hooks/useListings';
import { formatPriceWithUnit } from '../../utils/formatPrice';
import { getImageUrl } from '../../utils/imageUrl';

const ListingRowCard = ({ listing }) => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const { language } = useLanguage();
  const { isFavorite, addToFavorites, removeFromFavorites } = useListings();

  if (!listing) return null;

  const { id, slug, title, quartier, city, price, images } = listing;
  // L'API renvoie price_type (snake_case), le repli priceType couvre d'anciennes données locales
  const priceType = listing.price_type || listing.priceType;

  const mainImage = images && images.length > 0 ? getImageUrl(images[0]) : '/images/placeholder.png';
  const favorite = isFavorite(id);

  const handleFavoriteClick = (e) => {
    e.stopPropagation();
    if (favorite) {
      removeFromFavorites(id);
    } else {
      addToFavorites(id);
    }
  };

  const styles = {
    card: {
      display: 'flex',
      flexDirection: 'column',
      width: '200px',
      flexShrink: 0,
      backgroundColor: theme.bgCard,
      borderRadius: '12px',
      overflow: 'hidden',
      cursor: 'pointer',
      border: `1px solid ${theme.border}`,
      transition: 'transform 200ms ease-in-out',
    },
    imageContainer: {
      position: 'relative',
      width: '100%',
      height: '130px',
      backgroundColor: theme.bgInput,
    },
    image: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    favoriteButton: {
      position: 'absolute',
      top: '8px',
      right: '8px',
      width: '32px',
      height: '32px',
      borderRadius: '50%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      backdropFilter: 'blur(4px)',
      border: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      fontSize: '15px',
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
      padding: '10px 12px 12px',
    },
    title: {
      fontSize: '14px',
      fontWeight: '600',
      color: theme.textPrimary,
      lineHeight: '1.3',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    location: {
      fontSize: '12px',
      color: theme.textSecondary,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    price: {
      fontSize: '14px',
      fontWeight: '700',
      color: theme.gold,
      marginTop: '2px',
    },
  };

  return (
    <div
      style={styles.card}
      onClick={() => navigate(`/listing/${slug}`)}
      onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
      onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
    >
      <div style={styles.imageContainer}>
        <img src={mainImage} alt={title} style={styles.image} />
        <button style={styles.favoriteButton} onClick={handleFavoriteClick}>
          {favorite ? '❤️' : '🤍'}
        </button>
      </div>
      <div style={styles.content}>
        <div style={styles.title}>{title}</div>
        <div style={styles.location}>📍 {quartier}, {city}</div>
        <div style={styles.price}>{formatPriceWithUnit(price, priceType, language)}</div>
      </div>
    </div>
  );
};

export default ListingRowCard;